import { ViewChild, ElementRef, NgZone,Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {SiteuserService} from '../../services/siteuser.service';
import { MapsAPILoader} from '@agm/core';
import {LanguageService} from '../../services/language.service';
declare var google:any;

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.css']
})
export class AddAddressComponent implements OnInit{
  isError:boolean;
  errmsg:string;
  isSuccess:boolean;
  sucMsg:string = '';
  isLoading:boolean;
  isLoadingdetect:boolean;
    
  private geoCoder;
  address:string;
  latitude: number;
  longitude: number;
  zoom: number;
  country:string;
  state:string;
  city:string;
  address_1:string;
  address_2:string;
  apartment:string;
  isMobile:boolean;
  showLang:string;

  @ViewChild('search') 
  public searchElement: ElementRef;
  addrerrmsg: string;
  addr2errmsg: string;

  constructor(private router:Router, private http:HttpClient, 
    private usrObj:SiteuserService,
    private mapsAPILoader: MapsAPILoader,private ngZone: NgZone,private langObj:LanguageService) { 
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
    }

  ngOnInit(): void {
    
    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    if (window.screen.width <= 768) { 
      this.isMobile = true;
    }

    this.mapsAPILoader.load().then(() => { 

      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          // console.log("position", position)
          // this.latitude = position.coords.latitude;
          // this.longitude = position.coords.longitude;
        });
      }
      this.zoom = 8;
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement);
      // autocomplete.setFields(
      //   ['address_components', 'geometry', 'icon', 'name']);
      autocomplete.setComponentRestrictions({'country': ['are']});
      autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this.address_2='';
          this.address_1=place.name;
          console.log("place", place);
          
          for (var i = 0; i < place.address_components.length; i++) {
                  
            var component = place.address_components[i];
            if(component.types.includes('street_number')) {
                // this.address_2 = component.long_name;
                this.address_1 = this.address_1 + ', ' + component.long_name;
            }
            else if(component.types.includes('route')) {
              if(this.address_2 != undefined && this.address_2 != '' ){
                // this.address_2 = this.address_2 + ','+ component.long_name;
              }else{
                // this.address_2 = component.long_name;
              }
              this.address_1 = this.address_1 + ', ' + component.long_name;

            }
            else if(component.types.includes('sublocality')) {
              if(this.address_2 != undefined && this.address_2 != '' ){
                // this.address_2 = this.address_2 + ','+ component.long_name;
              }else{
                // this.address_2 = component.long_name;
              }
              this.address_1 = this.address_1 + ', ' + component.long_name;
            }
            else if(component.types.includes('locality')) {
                  this.city = component.long_name;
            }
            else if (component.types.includes('administrative_area_level_1')) {
                  this.state = component.long_name;
            }
            else if (component.types.includes('country')) {
                  this.country = component.long_name;
            }

          }

        });
      });
    });
  }
  
  onChanegAddress(value) {
    if (value == '') {
      this.latitude = undefined;
      this.longitude = undefined;
    }
  }
  
  onAddAddressSubmit(frm: NgForm) {
    // console.log(frm.value)
    if (this.apartment === undefined) {
      this.errmsg = "This field is required!"
      return
    } else {
      this.errmsg = ""
    }
    if (this.latitude === undefined) {
      this.addrerrmsg = "Address must select from the list closest landmark to you."
      return
    } else {
      this.addrerrmsg = ""
    }
    if (this.address_2 === undefined || this.address_2 == '') {
      this.addr2errmsg = "Enter your full address manually here."
      return
    } else {
      this.addr2errmsg = ""
    }
    var isdeflt = 0;
    if(frm.value.isDefault){isdeflt = 1;}
    this.isLoading=true;
    this.http.post(env.apiurl+'add-delivery-address', {
      siteuser_id:this.usrObj.getLoggedinId(),
      userName:frm.value.userName,
      phoneNumber:'+971'+frm.value.phoneNumber,
      address_one: frm.value.address_one,
      address_two:frm.value.address_two,
      apartment:frm.value.apartment,
      city:frm.value.city,
      state:frm.value.state,
      country:frm.value.country,
      lat:frm.value.lat,
      long:frm.value.long,
      isDefault:isdeflt
    }).subscribe(rawData=>{
      this.isLoading = false;
      this.isLoadingdetect=false;
      if (rawData['success'] == true){
        this.isError = false;
        this.isSuccess = true;
        this.sucMsg = rawData['message'];
        this.router.navigate(['my-account']); 
      }else{
        this.isLoading=false;
        this.isLoadingdetect=false;
        this.isError = true;
        this.isSuccess = false;
        this.errmsg = rawData['data'];
      }
    });

  }

  initMap(){
    this.isLoadingdetect=true;
    this.isLoading=false;
    //maps goes here
    this.mapsAPILoader.load().then(() => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          
          this.geoCoder.geocode({ 'location': { lat: this.latitude, lng: this.longitude } },
          (results, status) => {
            // console.log(results);
            if (status === 'OK') {
              if (results[0]) {
                this.zoom = 12;
                this.address = results[0].address_components;
                this.address_2='';
                this.address_1='';
                this.isLoadingdetect=false;
                this.isLoading=false;
                for (var i = 0; i < results[0].address_components.length; i++) {
                  
                  var component = results[0].address_components[i];
                  if(component.types.includes('premise')) {
                      this.address_1 = component.long_name;
                  }
                  else if(component.types.includes('street_number')) {
                    if(this.address_1 != undefined && this.address_1 != '' ){
                      this.address_1 = this.address_1 + ','+ component.long_name;
                    }else{
                      this.address_1 = component.long_name;
                    }
                  }
                  else if(component.types.includes('route')) {
                    if(this.address_1 != undefined && this.address_1 != '' ){
                      this.address_1 = this.address_1 + ','+ component.long_name;
                    }else{
                      this.address_1 = component.long_name;
                    }
                  }
                  else if(component.types.includes('sublocality')) {
                    if(this.address_1 == '' ){
                      this.address_1 = component.long_name;
                    }else{
                      this.address_2 = component.long_name;
                    }
                    
                  }
                 else if(component.types.includes('neighborhood')) {
                    if(this.address_1 == '' ){
                      this.address_1 = component.long_name;
                    }else{
                      this.address_2 = component.long_name;
                    }
                    
                  }
                  else if(component.types.includes('locality')) {
                        this.city = component.long_name;
                  }
                  else if (component.types.includes('administrative_area_level_1')) {
                        this.state = component.long_name;
                  }
                  else if (component.types.includes('country')) {
                        this.country = component.long_name;
                  }
      
                }
                
              } else {
                alert('No results found');
              }
            } else {
              alert('Geocoder failed due to: ' + status);
            }
          });
        });
      }
      this.zoom = 8;
      this.geoCoder = new google.maps.Geocoder;
    });
  }

  
}